import * as React from 'react';
import { useContext } from 'react';
import Wrapper from '@components/Wrapper';
import closeBtnIcon from '@icons/closeBtnIcon';
import { GlobalStateContext } from '@context/context';
import * as styles from './style.module.scss';

const {
  infoBox,
  infoBox__container,
  infoBox__main,
  infoBox__text,
  infoBox__rightFloat,
  infoBox__close,
} = styles;

const AcademyBanner = () => {
  const { setShowInfoBox } = useContext(GlobalStateContext);

  return (
    <div className={`${infoBox}`}>
      <Wrapper>
        <div className={infoBox__container}>
          <div className={infoBox__main}>
            {/*<div className={infoBox__logo}>
              <StaticImage
                placeholder="none"
                src="../../images/icons/wiredminds-campaign-img-mob.png"
                alt="WiredMinds campaign banner image"
              />
            </div>*/}
            <div className={infoBox__text}>
              <p>
                We’re always adding new Academy videos, so be sure to check back
                often for the latest updates. If you don’t find what you’re
                looking for, our{' '}
                <a href="https://help.dealfront.com/en/">Help Center</a> and
                Support Team are here to help!
              </p>
              {/*<Link to="/blog">
                {t('wiredminds_banner_link')}
              </Link>*/}
            </div>
          </div>
          <div className={infoBox__rightFloat}>
            {/*<Link to={language === 'de' ? '/blog/dealfront-uebernimmt-wiredminds' : "/blog/dealfront-acquires-wiredminds"}>
              {t('wiredminds_banner_link')}
            </Link>*/}
            <div
              onClick={() => setShowInfoBox(false)}
              className={infoBox__close}
            >
              {closeBtnIcon}
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default AcademyBanner;
